<template>
    <div>
      <h2>Rooms</h2>
      <ul>
        <li v-for="room in tenantRooms" :key="room.id">
          <router-link :to="`/manage/rooms/${room.id}`">{{ room.name }}</router-link>
        </li>
      </ul>
    </div>
  </template>

  <script>
  import { mapState } from 'vuex';

  export default {
    name: 'Rooms',
    computed: {
      ...mapState(['tenantRooms']),
    },
  };
  </script>
